import { Link as RouterLink } from "react-router-dom";
import { Icon } from "@iconify/react";
import eyeFill from "@iconify/icons-eva/eye-fill";
import eyeOffFill from "@iconify/icons-eva/eye-off-fill";
import {
  TextField,
  Stack,
  Typography,
  IconButton,
  InputAdornment,
  Link,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import { _admin_login } from "../../DAL/login/login";
import { _set_user_to_localStorage } from "../../DAL/localStorage/localStorage";

import { login } from "../../assets";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useContentSetting } from "../../Hooks/ContentContext/ContentSettingState";

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [email, setemail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { handleUserInfo } = useContentSetting();

  const { enqueueSnackbar } = useSnackbar();
  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const data = { email: email, password: newPassword };
    const response = await _admin_login(data);

    if (response.code === 200) {
      localStorage.setItem("token", response.token);
      handleUserInfo(response.user);
      _set_user_to_localStorage(response.user);
      enqueueSnackbar(response.message, { variant: "success" }); //we have error message in res.message
      setIsLoading(false);
      navigate("/dashboard");
    } else {
      enqueueSnackbar(response.message, { variant: "error" }); //we have error message in res.message
      setIsLoading(false);
    }
  };
  return (
    <>
      <div className="container">
        <div className="row w-100">
          <div className="col-sm-5 pt-5">
            <div className="container">
              <div className="card image-container">
                <Typography
                  variant="h3"
                  sx={{ px: 5, mt: 10, mb: 5, fontSize: "2.5vw" }}>
                  Hi, Welcome Back
                </Typography>
                <img src={login} alt="Login" />
              </div>
            </div>
          </div>
          <div className="col-sm-7 pt-5">
            <div className="container">
              <div className="form-container">
                <Stack sx={{ mb: 3 }}>
                  <Typography variant="h5" gutterBottom>
                    Welcome To Petfish Catalogue
                  </Typography>
                  <Typography sx={{ color: "text.secondary" }}>
                    Enter your details below.
                  </Typography>
                </Stack>
                <form autoComplete="off" onSubmit={handleSubmit}>
                  <Stack spacing={2}>
                    <TextField
                      fullWidth
                      type="email"
                      label="Email address"
                      value={email}
                      onChange={(e) => setemail(e.target.value)}
                      required
                    />

                    <TextField
                      fullWidth
                      autoComplete="current-password"
                      type={showPassword ? "text" : "password"}
                      label="Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={handleShowPassword} edge="end">
                              <Icon
                                icon={showPassword ? eyeFill : eyeOffFill}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>

                  <div className="text-end forgot-text">
                    <Link
                      variant="subtitle2"
                      component={RouterLink}
                      to="/forgot-password">
                      Forgot Password?
                    </Link>
                  </div>

                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-end"></Stack>

                  <LoadingButton
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    loading={isLoading}>
                    Login
                  </LoadingButton>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
